import { render, staticRenderFns } from "./bekChannelGuide.vue?vue&type=template&id=33132508&scoped=true&"
import script from "./bekChannelGuide.ts?vue&type=script&lang=ts&"
export * from "./bekChannelGuide.ts?vue&type=script&lang=ts&"
import style0 from "./bekChannelGuide.less?vue&type=style&index=0&id=33132508&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33132508",
  null
  
)

export default component.exports